export class TimeZone {
    static readonly AsiaJakarta = 'Asia/Jakarta'
}

export default TimeZone